module.exports = __webpack_public_path__ + "img/yiqixuehoutai.797a2085.png";